// Image CDN helper — adds transform params for smaller, faster payloads and
// returns a `srcSet` for responsive loading. Handles:
//   • Unsplash (auto=format&fm=webp&w=…)
//   • Pexels (auto=compress&cs=tinysrgb&w=…)
//   • Our own object-storage proxy /api/files/* (backend does Pillow WebP resize when ?w=…)
//   • Legacy local /api/uploads/* — passthrough (no server-side resize available)
const cdnParams = (u, width, quality = 75) => {
  if (!u) return u;
  if (u.includes('images.unsplash.com')) {
    // Strip any existing width/quality/format so we don't serve the full-size q=85 original.
    const base = u.split('?')[0];
    return `${base}?auto=format&fit=crop&fm=webp&w=${width}&q=${quality}`;
  }
  if (u.includes('images.pexels.com')) {
    const base = u.split('?')[0];
    return `${base}?auto=compress&cs=tinysrgb&fit=crop&w=${width}&h=${Math.round(width * 4 / 3)}`;
  }
  if (u.includes('/api/files/')) {
    const sep = u.includes('?') ? '&' : '?';
    return `${u}${sep}w=${width}`;
  }
  return u;
};

const isTransformable = (u) => {
  if (!u || !u.startsWith('http')) return false;
  return (
    u.includes('images.unsplash.com') ||
    u.includes('images.pexels.com') ||
    u.includes('/api/files/')
  );
};

/** Single transformed URL — use for <video poster>, backgrounds, or <img> without srcSet. */
export const cdnSrc = (u, width = 800, quality = 75) => {
  if (!isTransformable(u)) return u;
  return cdnParams(u, width, quality);
};

/**
 * Returns a src + srcSet + sizes bundle for an <img/>.
 * opts: { widths:[…], sizes:'…', quality:N }
 */
export const cdnImage = (u, baseWidth = 600, opts = {}) => {
  if (!isTransformable(u)) {
    return { src: u, srcSet: undefined, sizes: undefined };
  }
  const widths = opts.widths || [320, 480, 640, 960, 1280];
  const sizes = opts.sizes || '(max-width: 640px) 45vw, (max-width: 1024px) 30vw, 20vw';
  const quality = opts.quality || 75;
  const srcSet = widths.map((w) => `${cdnParams(u, w, quality)} ${w}w`).join(', ');
  return {
    src: cdnParams(u, baseWidth, quality),
    srcSet,
    sizes,
  };
};
